import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import PlanGate from "@/components/PlanGate";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ChoosePlan from "@/pages/ChoosePlan";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Course from "@/pages/Course";
import ModuleDetail from "@/pages/ModuleDetail";
import Charts from "@/pages/Charts";
import Exercises from "@/pages/Exercises";
import Simulator from "@/pages/Simulator";
import Calculator from "@/pages/Calculator";
import Quizzes from "@/pages/Quizzes";
import QuizDetail from "@/pages/QuizDetail";
import Glossary from "@/pages/Glossary";
import Videos from "@/pages/Videos";
import Tutor from "@/pages/Tutor";
import Progress from "@/pages/Progress";
import ManageSubscription from "@/pages/ManageSubscription";

const P = ({ children }) => (
  <ProtectedRoute>
    <PlanGate>
      <Layout>{children}</Layout>
    </PlanGate>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/choose-plan" element={<ProtectedRoute><ChoosePlan /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
            <Route path="/" element={<P><Home /></P>} />
            <Route path="/course" element={<P><Course /></P>} />
            <Route path="/course/:id" element={<P><ModuleDetail /></P>} />
            <Route path="/charts" element={<P><Charts /></P>} />
            <Route path="/exercises" element={<P><Exercises /></P>} />
            <Route path="/simulator" element={<P><Simulator /></P>} />
            <Route path="/calculator" element={<P><Calculator /></P>} />
            <Route path="/quizzes" element={<P><Quizzes /></P>} />
            <Route path="/quizzes/:id" element={<P><QuizDetail /></P>} />
            <Route path="/glossary" element={<P><Glossary /></P>} />
            <Route path="/videos" element={<P><Videos /></P>} />
            <Route path="/tutor" element={<P><Tutor /></P>} />
            <Route path="/progress" element={<P><Progress /></P>} />
            <Route path="/subscription" element={<P><ManageSubscription /></P>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
